import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import uuid from "uuid/v4"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import GetInsWizard from "@irati/insights/apollo/client/query/InsWizard"
import question from "@irati/insights/apollo/client/defaultData/question"
import UpdateInsWizard from "@irati/insights/apollo/client/mutation/InsWizard"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"

import {InputWrapper, ValidationActionButton, ButtonWrapper} from "./QuestionEditorStyles"
import QuestionEditorLabel from "./QuestionEdititorLabel"

const StyledInput = styled(Input)`
  flex: 1;
`

class AddQuestion extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    className: null,
    disabled: false
  }

  state = {
    text: ""
  }

  handleChange = (text) => {
    this.setState({text})
  }

  render() {
    const {text} = this.state
    const {formatMessage, className, disabled} = this.props

    return (
      <GetInsWizard>
        {({questions}) => {
          return (
            <UpdateInsWizard>
              {(update, {cycle: {tenant: tenantUuid}}) => {
                const addQuestion = () => {
                  if (!text) return null
                  const newQuestion = {...question, tenantUuid, text, uuid: uuid()}
                  const params = {questions: [...questions, newQuestion]}
                  update({variables: {params}})
                  this.setState({text: ""})
                }
                return (
                  <InputWrapper>
                    <StyledInput
                      disabled={disabled}
                      flush
                      placeholder={formatMessage({id: "insights.customSurvey.questionInput.placeholder"})}
                      name="addQuestion"
                      value={text}
                      validation={Validation.string().max(255)}
                      className={`${className} clearfix`}
                      onChange={this.handleChange}
                      label={<QuestionEditorLabel />} />
                    <ButtonWrapper>
                      <ValidationActionButton disabled={disabled} primary small onClick={addQuestion}>
                        <FormattedMessage id="insights.customSurvey.questionCta.add" />
                      </ValidationActionButton>
                    </ButtonWrapper>
                  </InputWrapper>
                )
              }}
            </UpdateInsWizard>
          )
        }}
      </GetInsWizard>
    )
  }
}

export default injectIntl(AddQuestion)
